import { connect } from 'react-redux'
import { Row, Col, Form, Input, Select, Button, Checkbox, Modal, BackTop, notification } from 'antd'
import * as actions from '../redux/actions'
import { privacyTitle } from '../constant/global_constant'
import Privacy from '../components/Privacy'

const formText = '聯絡我們'
const buttonText = '限時限量試讀體驗'
const FormItem = Form.Item
const Option = Select.Option
const checkTel = (rule, value, callback) => {
  if(!/^\d{10,15}$/.test(value)){
    callback(rule.message)
  }
  callback()
}
const serialize = (obj) => {
  var str = []
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]))
    }
  return str.join("&")
}

class FooterValidationForm extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.user.loading !== this.props.user.loading && !nextProps.user.loading) {
      if (nextProps.user.code === 1) {
        notification.success({
          message: '恭喜您',
          description: '已報名成功',
        })
      } else {
        notification.error({
          message: '報名失敗，請重新填單',
          description: nextProps.user.msg || '已報名失敗',
        })
      }
    }
  }

  showModal = (e) => {
    e.preventDefault()
    e.stopPropagation()
    Modal.info({
      width: '60%',
      title: privacyTitle,
      content:  <Privacy />,
      onOk() {},
      okText: '閱讀完畢'
    });
  }

  onSave = () => {
    const { form, id, type, data } = this.props
    form.validateFields((err, values) => {
      if (err) {
        notification.error({
          message: '申請失敗',
          description: '資料尚未填妥，請填寫完後再重新送出。',
        });
        return;
      }

      VA.remoteLoad({
        whiteLabel: { id: 8, siteId: 1207, domain: 'vbtrax.com' },
        conversion: true,
        conversionData: {
          step: 'default', // conversion name
          adv_uniq_id: values.tel.substring(values.tel.length - 6, values.tel.length) // unique transaction id
        },
        locale: "en-US",
        mkt: true
      })

      if (id) {
        values.source = data.title
      } else {
        values.source = type
      }

      delete values.privacy

      this.props.addContact(serialize(values))
      form.resetFields()
    })
  }

  render() {
    const { form, dispatch, error, handleSubmit, pristine, reset, submitting, data } = this.props
    const { getFieldDecorator, getFieldError, isFieldTouched, getFieldValue } = form
    const nameError = isFieldTouched('guest_name') && getFieldError('guest_name')
    const telError = isFieldTouched('tel') && getFieldError('tel')
    const emailError = isFieldTouched('email') && getFieldError('email')
    const ageError = isFieldTouched('age') && getFieldError('age')
    const areaError = isFieldTouched('area') && getFieldError('area')
    const privacyError = isFieldTouched('privacy') && getFieldError('privacy')

    return (
      <section id="contact" className="section-contact">
      <h1>{data && data.form_text || formText}</h1>

      <div className="section-contact-form">
        <Form>
          <Row>
            <Col span={12} xs={24} md={12}>
              <FormItem
                wrapperCol={{ span: 23 }}
                validateStatus={nameError ? 'error' : ''}
                help={nameError || ''}
              >
                {getFieldDecorator('guest_name', {
                  rules: [
                    { required: true, message: '請填入學員姓名' },
                    { max: 30, message: '課程標題過長，僅限 30 個字內' },
                  ],
                })(
                  <Input placeholder="學員姓名" style={{ height: '60px' }} />
                )}
              </FormItem>
            </Col>
            <Col span={12} xs={24} md={12}>
              <FormItem
                wrapperCol={{ span: 23 }}
                validateStatus={telError ? 'error' : ''}
                help={telError || ''}
              >
                {getFieldDecorator('tel', {
                  rules: [
                    { required: true, message: '請填入家長手機號碼' },
                    { validator: checkTel, message: '家長手機號碼格式錯誤，僅限數字' },
                  ],
                })(
                  <Input placeholder="家長手機號碼，僅限數字" style={{ height: '60px' }} />
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12} xs={24} md={12}>
              <FormItem
                wrapperCol={{ span: 23 }}
                validateStatus={emailError ? 'error' : ''}
                help={emailError || ''}
              >
                {getFieldDecorator('email', {
                  rules: [
                    { type: 'email', message: '家長信箱格式錯誤' },
                    { required: true, message: '請填入家長信箱' }
                  ],
                })(
                  <Input placeholder="家長信箱" style={{ height: '60px' }} />
                )}
              </FormItem>
            </Col>
            <Col span={6} xs={24} md={6}>
              <FormItem
                wrapperCol={{ span: 23 }}
                validateStatus={ageError ? 'error' : ''}
                help={ageError || ''}
              >
                {getFieldDecorator('age', {
                  rules: [{ required: true, message: '請填入學員年齡' }],
                })(
                  <Select size="large" style={{ height: '60px' }} placeholder="學員年齡">
                    <Option value="1">1</Option>
                    <Option value="2">2</Option>
                    <Option value="3">3</Option>
                    <Option value="4">4</Option>
                    <Option value="5">5</Option>
                    <Option value="6">6</Option>
                    <Option value="7">7</Option>
                    <Option value="8">8</Option>
                    <Option value="9">9</Option>
                    <Option value="10">10</Option>
                    <Option value="11">11</Option>
                    <Option value="12">12</Option>
                    <Option value="13">13</Option>
                    <Option value="14">14</Option>
                    <Option value="15">15</Option>
                    <Option value="16">16</Option>
                    <Option value="17">17</Option>
                    <Option value="18">18</Option>
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col span={6} xs={24} md={6}>
              <FormItem
                wrapperCol={{ span: 22 }}
                validateStatus={areaError ? 'error' : ''}
                help={areaError || ''}
              >
                {getFieldDecorator('area', {
                  rules: [{ required: true, message: '請填入居住地' }],
                })(
                  <Select size="large" placeholder="居住地">
                    <Option value="臺北市">臺北市</Option>
                    <Option value="新北市">新北市</Option>
                    <Option value="桃園市">桃園市</Option>
                    <Option value="臺中市">臺中市</Option>
                    <Option value="臺南市">臺南市</Option>
                    <Option value="高雄市">高雄市</Option>
                    <Option value="基隆市">基隆市</Option>
                    <Option value="新竹市">新竹市</Option>
                    <Option value="嘉義市">嘉義市</Option>
                    <Option value="新竹縣">新竹縣</Option>
                    <Option value="苗栗縣">苗栗縣</Option>
                    <Option value="彰化縣">彰化縣</Option>
                    <Option value="南投縣">南投縣</Option>
                    <Option value="雲林縣">雲林縣</Option>
                    <Option value="嘉義縣">嘉義縣</Option>
                    <Option value="屏東縣">屏東縣</Option>
                    <Option value="宜蘭縣">宜蘭縣</Option>
                    <Option value="花蓮縣">花蓮縣</Option>
                    <Option value="臺東縣">臺東縣</Option>
                    <Option value="澎湖縣">澎湖縣</Option>
                    <Option value="金門縣">金門縣</Option>
                    <Option value="連江縣">連江縣</Option>
                  </Select>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row style={{ display: 'flex', justifyContent: 'center' }}>
            <Col span={6} xs={24} md={14} lg={7}>
              <FormItem
                wrapperCol={{ span: 22 }}
                validateStatus={privacyError ? 'error' : ''}
                help={privacyError || ''}
              >
                {getFieldDecorator('privacy', {
                  rules: [{ required: true, message: '請先閱讀並同意會員服務條款及隱私權條款' }],
                  valuePropName: 'checked',
                })(
                  <Checkbox>
                    我已閱讀並同意
                    <a onClick={this.showModal}>會員服務條款及隱私權條款</a>
                  </Checkbox>
                )}
              </FormItem>
            </Col>
          </Row>
          <Row style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              size="large"
              style={{
                backgroundColor: data && data.button_bg_color || '#f47645',
                color: data && data.button_color || '#fff',
              }}
              onClick={this.onSave}
            >
              {data && data.button_text || buttonText}
            </Button>
          </Row>
        </Form>
        <BackTop />
      </div>
      <style jsx>{`
        section {
          background-color: #f7f7f7;
          padding-bottom: 5%;
        }

        h1 {
          text-align: center;
          font-size: 2em;
          font-weight: bold;
          padding: 5% 0 2%;
          color: ${data && data.form_color};
        }

        .section-contact-form {
          padding: 2em 2em 0;
        }

        div :global(.ant-select-lg .ant-select-selection__rendered) {
          line-height: 60px;
        }

        div :global(.ant-select-lg .ant-select-selection--single) {
          height: 60px;
        }

        div :global(.ant-btn-lg) {
          width: 200px;
          height: 50px;
          line-height: 50px;
          background: #f47645;
          border: 0;
          color: #fff;
        }

        @media(max-width: 768px){
          section {
            padding: 2em 0 4em;
          }

          div :global(.ant-btn-lg) {
            width: 100%;
          }
        }
      `}</style>
    </section>
    )
  }
}

export default connect(
  state => ({
    user: state.user,
  }),
  { addContact: actions.addContact }
)(Form.create()(FooterValidationForm))